<div *ngIf="!!selectedRow" fxFlexFill>
  <div class="detailsPanelBody" *ngIf="!!dataDetail">
    <form class="example-form" #updateForm="ngForm">

      <!--  ************************************  -->
      <!--            USER FIRSTNAME              -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField formFieldMargin">
        <mat-label>{{'CHARGER.NAME' | translate}}</mat-label>
        <input matInput required #userFirstname="ngModel" type="text" name="userFirstname" [disabled]="!editMode" [(ngModel)]="dataDetail.name">
        <mat-error *ngIf="userFirstname.invalid">
          {{'CHARGER.NAME_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--  ************************************  -->
      <!--             USER LASTNAME              -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField formFieldMargin">
        <mat-label>{{'CHARGER.LABEL' | translate}}</mat-label>
        <input matInput required #label="ngModel" type="text" name="label" [disabled]="!editMode" [(ngModel)]="dataDetail.label">
        <mat-error *ngIf="label.invalid">
          {{'CHARGER.LABEL_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--  ************************************  -->
      <!--             USER LASTNAME              -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField formFieldMargin">
        <mat-label>{{'CHARGER.POWER' | translate}}</mat-label>
        <input matInput required #userLastname="ngModel" type="number" name="userLastname" [min]="0" [disabled]="!editMode" [(ngModel)]="dataDetail.wattPower">
        <mat-error *ngIf="userLastname.invalid">
          {{'CHARGER.POWER_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
      </mat-form-field>
    </form>
  </div>

</div>
